import { render, staticRenderFns } from "./WhitepaperStats.vue?vue&type=template&id=35dfb8ea&scoped=true&"
import script from "./WhitepaperStats.vue?vue&type=script&lang=js&"
export * from "./WhitepaperStats.vue?vue&type=script&lang=js&"
import style0 from "./WhitepaperStats.vue?vue&type=style&index=0&id=35dfb8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dfb8ea",
  null
  
)

export default component.exports